/**
 * Pregled — the landing view: hero, the four counts, the three "how do you
 * want to continue" cards (web catalogue, KingCAD tree, sources).
 */

import { docsCopy } from '../docsCopy.js';
import { esc } from '../docsHtml.js';
import type { DocsCatalogue } from '../docsModel.js';
import { docsPath } from '../docsRouter.js';

export function renderPregled(cat: DocsCatalogue): string {
  const c = docsCopy;
  const katalogHref = docsPath({ view: 'web' });
  const cadHref = docsPath({ view: 'cad' });
  const viriHref = docsPath({ view: 'viri' });
  const stat = (n: number, label: string): string =>
    `<div class="docs-stat"><div class="docs-stat-n">${n}</div><div class="docs-stat-l">${esc(label)}</div></div>`;
  const card = (href: string, eyebrow: string, title: string, text: string): string => `
      <a class="docs-card" href="${esc(href)}" data-docs-link>
        <span class="docs-card-eyebrow">${esc(eyebrow)}</span>
        <span class="docs-card-title">${esc(title)}</span>
        <span class="docs-card-text">${esc(text)}</span>
      </a>`;

  return `
    <div class="docs-pregled">
      <div class="docs-eyebrow">${esc(c.hero.eyebrow)}</div>
      <h1 class="docs-hero-title" tabindex="-1">${esc(c.hero.title)}</h1>
      <p class="docs-hero-lead">${esc(c.hero.lead)}</p>
      <div class="docs-hero-actions">
        <a class="docs-btn-primary" href="${esc(katalogHref)}" data-docs-link>${esc(c.hero.cta)}</a>
        <a class="docs-btn-link" href="${esc(viriHref)}" data-docs-link>${esc(c.hero.viriLink)}</a>
      </div>
      <div class="docs-stats">
        ${stat(cat.counts.layers, c.stats.layers)}
        ${stat(cat.counts.cadLayers, c.stats.cadLayers)}
        ${stat(cat.counts.sources, c.stats.sources)}
        ${stat(cat.counts.themes, c.stats.themes)}
      </div>
      <h2 class="docs-h2">${esc(c.next.heading)}</h2>
      <div class="docs-cards">
        ${card(katalogHref, c.next.katalog.eyebrow, c.next.katalog.title, c.next.katalog.text(cat.counts.layers))}
        ${card(cadHref, c.next.cad.eyebrow, c.next.cad.title, c.next.cad.text(cat.counts.cadLayers, cat.counts.cadFolders))}
        ${card(viriHref, c.next.viri.eyebrow, c.next.viri.title, c.next.viri.text(cat.counts.sources))}
      </div>
    </div>`;
}
